import { Clock, Flex } from "@components/index";
import { MetaDay } from "@src/common/components/internal/MetaDay";
import { RiskLosingDay } from "@src/common/components/internal/RiskLosingDay";
import { useLayoutCollapseContext } from "@template/contexts/LayoutCollapse.context";
import { useGanttDataContext } from "../../contexts/GanttData.context";
import { CollapseButton } from "../CollapseButton";
import {
  CollapseHeaderButton,
  DatePickerFilter,
  FiltersButton,
  ViewDropDown,
} from "./components";
import styles from "./Header.module.scss";

const Header: React.FC<React.PropsWithChildren> = () => {
  const {
    isHeaderCollapsed,
    isSubheaderCollapsed,
    toggleHeader,
    toggleSubheader,
  } = useLayoutCollapseContext();

  const { rawData } = useGanttDataContext();

  const contentClass = isSubheaderCollapsed
    ? `${styles.content} ${styles["content-collapsed"]}`
    : styles.content;

  return (
    <Flex.Row alignItems="center" className={styles.wrapper}>
      <div className={contentClass}>
        <div className={styles.title}>Monitoramento Timeline</div>
        <Flex.Row alignItems="center" gap="20px">
          <Clock />
          <DatePickerFilter />
          <ViewDropDown />

          <RiskLosingDay riskLevel={rawData?.timelineRisk} />
          <MetaDay level={rawData?.timelineGoal} />

          <CollapseHeaderButton
            isActive={isHeaderCollapsed}
            onClick={toggleHeader}
          />
          <FiltersButton />
        </Flex.Row>
      </div>
      <CollapseButton
        isCollapsed={isSubheaderCollapsed}
        onClick={toggleSubheader}
        direction="up"
        className={
          isSubheaderCollapsed
            ? `${styles["collapse-btn"]} ${styles["collapse-btn-down"]}`
            : styles["collapse-btn"]
        }
      />
    </Flex.Row>
  );
};

export default Header;
